import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String }

  connect() {
    this.overlay = document.querySelector(".video-popup-overlay")
    this.iframe = document.querySelector(".video-popup-overlay iframe")

    // Listen for escape key
    this.boundEscapeHandler = this.handleEscape.bind(this)
    document.addEventListener("keydown", this.boundEscapeHandler)

    // Close button handler
    const closeBtn = document.querySelector(".video-popup-close")
    if (closeBtn) {
      this.boundCloseHandler = this.close.bind(this)
      closeBtn.addEventListener("click", this.boundCloseHandler)
    }

    // Overlay click handler
    if (this.overlay) {
      this.boundOverlayHandler = this.closeOnOverlay.bind(this)
      this.overlay.addEventListener("click", this.boundOverlayHandler)
    }
  }

  disconnect() {
    document.removeEventListener("keydown", this.boundEscapeHandler)

    const closeBtn = document.querySelector(".video-popup-close")
    if (closeBtn && this.boundCloseHandler) {
      closeBtn.removeEventListener("click", this.boundCloseHandler)
    }

    if (this.overlay && this.boundOverlayHandler) {
      this.overlay.removeEventListener("click", this.boundOverlayHandler)
    }
  }

  open(event) {
    event.preventDefault()
    event.stopPropagation()

    if (this.overlay && this.iframe) {
      this.iframe.src = this.urlValue
      this.overlay.classList.add("is-open")
      document.body.style.overflow = "hidden"
    }
  }

  close() {
    if (this.overlay && this.iframe) {
      this.overlay.classList.remove("is-open")
      document.body.style.overflow = ""
      // Stop video by clearing src
      setTimeout(() => {
        this.iframe.src = ""
      }, 300)
    }
  }

  closeOnOverlay(event) {
    if (event.target === this.overlay) {
      this.close()
    }
  }

  handleEscape(event) {
    if (event.key === "Escape" && this.overlay && this.overlay.classList.contains("is-open")) {
      this.close()
    }
  }
}
